export default __webpack_public_path__ + "static/media/block-who-we-help-2.1d1975cc.webp";